import { render, staticRenderFns } from "./ColourMatchV2Modal.vue?vue&type=template&id=2f1c13d6&"
import script from "./ColourMatchV2Modal.vue?vue&type=script&lang=js&"
export * from "./ColourMatchV2Modal.vue?vue&type=script&lang=js&"
import style0 from "./ColourMatchV2Modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports